module.exports = __webpack_public_path__ + "img/wx-qrcode.d8087c4e.jpg";